import React, { Component } from 'react'
import {Modal,Col,Container, Row, Form, Button} from 'react-bootstrap';
import {connect} from 'react-redux';
import * as actionTypes from '../../Action/Index';
import Loader from 'react-loader-advanced';
import Spinner from 'react-bootstrap/Spinner';
import SweetAlert from '../commonComponents/SweetAlert';
import ReusablePreview from '../extInterviewSchedule/Reusable_Preview'
import classes from './viewinterviewdetails.module.css'
import moment from 'moment';

export class ViewinterviewDetails extends Component {
    state={
        viewInterviewDetailsData:null,
        candidateResponse:null,
        interviewerResponse:null,
        jobProfile:null,
        endTime:null,
        interviewDate:null,
        startTime:null,

    }
   componentWillMount=()=>{
       this.props.viewInterviewDetails(this.props.interviewid)
   }
   
   componentWillReceiveProps=(nextProps)=>{
       if(nextProps.viewInterviewDetailsData!=null){
           this.setState({viewInterviewDetailsData:nextProps.viewInterviewDetailsData,
            candidateResponse:nextProps.viewInterviewDetailsData.candidateResponse,
            interviewerResponse:nextProps.viewInterviewDetailsData.interviewerResponse,
            jobProfile:nextProps.viewInterviewDetailsData.jobProfile,

            endTime:nextProps.viewInterviewDetailsData.invitePreview.endTime,
            interviewDate:nextProps.viewInterviewDetailsData.invitePreview.interviewDate,
            startTime:nextProps.viewInterviewDetailsData.invitePreview.startTime,
        })
       }
   }


    render() {
        if(this.state.viewInterviewDetailsData!==null){
        const months = ["Jan", "Feb", "Mar","Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            let current_datetime = new Date(this.state.interviewDate)
            var formatted_date = current_datetime.getDate() + " " + months[current_datetime.getMonth()]

            var timeobject = new Date(this.state.startTime);
            var hourstart = moment(timeobject).utc().format('hh:mm A')

            var timeobject = new Date(this.state.endTime);
            var hourend = moment(timeobject).utc().format('hh:mm A')
        }
        return (
           
           
            <Modal {...this.props} size="lg" aria-labelledby="contained-modal-title-vcenter">
            <Modal.Body>
            <Row className={classes.gapTop}>
                      <Col md={12}>
                      <fieldset className={classes.schedulerBorder}>  
                      <legend className={classes.schedulerBorder}>Interview Details</legend>
                      <Loader show={this.props.loader} message={ <Spinner animation="border" role="status"></Spinner> }
            foregroundStyle={{color: '#fbb03b'}}
            backgroundStyle={{backgroundColor: 'white'}}
            >
             
                    {this.state.viewInterviewDetailsData!==null?  
                      <ReusablePreview mode="interviewDetails"
                            candidateId={this.state.candidateResponse}

                            endTime={hourend}
                            
                            interviewDate={formatted_date}

                            interviewerId={this.state.interviewerResponse}
                           
                            jobProfileId={this.state.jobProfile}

                            startTime={hourstart}

                           
                      /> :null
                    }
                     </Loader>
           </fieldset>
            </Col>
             </Row>
             </Modal.Body>
            <Modal.Footer>
              <Button style={{padding: '1px 8px 1px 8px'}} variant = "warning" onClick={this.props.onHide}>Close</Button>
            </Modal.Footer>
           
          </Modal>
            
            
        )
    }
}


const mapStateToProps = state => {
    return{
        loader:state.employeeReducer.viewInterviewDetailsLoader,
        viewInterviewDetailsData: state.employeeReducer.viewInterviewDetailsData,
        viewInterviewDetailsFailMsg: state.employeeReducer.viewInterviewDetailsFailMsg,
        viewInterviewDetailsNetworkError: state.employeeReducer.viewInterviewDetailsNetworkError
    }
}

const mapDispatchToProps = dispatch => {
    return{
        viewInterviewDetails: (id) => dispatch(actionTypes.viewInterviewDetails(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewinterviewDetails);
